import { render, staticRenderFns } from "./dashboard-photovoltaic.vue?vue&type=template&id=225cba48&scoped=true"
import script from "./dashboard-photovoltaic.vue?vue&type=script&lang=js"
export * from "./dashboard-photovoltaic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225cba48",
  null
  
)

export default component.exports